
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';
    import buscador from './buscador.vue';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait, Random } from '@/__env/ext';
    import { VuePwaInstallMixin, BeforeInstallPromptEvent } from "vue-pwa-install";
import { ModoDeVistaActual } from '@/__env/main';
import { utimes } from 'fs';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public get Vista() { return this.Controlador.Vista; }

        public deferredPrompt: BeforeInstallPromptEvent = null;
        promptInstall()
        {
            this.deferredPrompt.prompt();
            this.deferredPrompt.userChoice.then( ( choiceResult ) =>
            {
                if ( choiceResult.outcome === "accepted" )
                {
                    console.log( "User accepted the install prompt" );
                } else
                {
                    console.log( "User dismissed the install prompt" );
                }

                this.deferredPrompt = null;
            } );
        }
        created()
        {
            this.$on( "canInstall", ( event: BeforeInstallPromptEvent ) =>
            {
                event.preventDefault();
                this.deferredPrompt = event;
            } );

        }

        async mounted()
        {

            await this.Controlador.Iniciar();
            this.Refrescar();
            await Wait( 100 );
            if ( !Utiles.NovedadesUsadas )
                Utiles.Novedades( true );
            Utiles.NovedadesUsadas = true;
            await Wait( 300 );
            this.ModoDeVistaActual = ModoDeVistaActual;

            if ( this.ModoDeVistaActual == 'browser tab' )
            {
                if ( Random.Enteros( 0, 100 ) > 95 && !Utiles.InstalarYaVisto )
                {
                    await Wait( 100 );
                    Utiles.Instalar( true );
                    Utiles.InstalarYaVisto = true;
                } else if ( Random.Enteros( 0, 100 ) > 90 )
                {
                    Utiles.InstalarYaVisto = false;
                }
            }
        }

        Instalar()
        {
            Utiles.Instalar( true );
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        public ModoDeVistaActual: string  = '';
        public Refresh: boolean = false;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
